export default "__VITE_ASSET__DCAnwwKZ__"